module.exports = __webpack_public_path__ + "static/media/Brugermanual_Webportal_06_2023.cd0c67b3.pdf";